module.exports = __webpack_public_path__ + "img/growth.54eb61c3.svg";